// extracted by mini-css-extract-plugin
export default {"top":"Private_top__QhYI5","btn":"Private_btn__UnToS"};